import React from 'react';
import './Card.scss';

interface CardProps {
  children?: React.ReactNode;
  variant?: 'default' | 'grey';
}
const Card = ({ children, variant = 'default' }: CardProps) => {
  return <div className={`card ${variant && variant}`}>{children}</div>;
};

export default Card;
